import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LobbyVerticalsComponent } from './lobby-verticals.component';
import { MobileModule } from '../../mobile/mobile.module';
import { cdnIconComponent } from './cdn-icon/cdn-icon';

@NgModule({
  declarations: [
    LobbyVerticalsComponent,
  ],
  imports: [
    cdnIconComponent,
    CommonModule,
    MobileModule,

  ],
  exports: [
    LobbyVerticalsComponent,
  ],
  providers: []
})
export class LobbyVerticalsModule { }
